export async function fetchSeguro<T = unknown>(url: string, options?: RequestInit): Promise<T> {
    const response = await fetch(url, {
        credentials: 'same-origin',
        ...options,
    });

    const raw = await response.text();
    let data: unknown;

    try {
        data = JSON.parse(raw);
    } catch {
        throw new Error('La respuesta del servidor no es JSON válido.');
    }

    if (
        data &&
        typeof data === 'object' &&
        'status' in data &&
        data.status === 'error' &&
        'message' in data &&
        typeof data.message === 'string' &&
        data.message.includes('Sesión inválida')
    ) {
        window.location.href = '/';
        throw new Error('Sesión expirada. Redirigiendo...');
    }

    return data as T;
}
